import styled from "styled-components"
import { Row, Col, Container } from "react-bootstrap";

import GinaG from '../../assets/staff/GinaG.png';
import AnnaG from '../../assets/staff/AnnaG.png';
import AnthonyG from '../../assets/staff/AnthonyG.jpg';
import AnuV from '../../assets/staff/AnuV.jpg';
import BethanyD from '../../assets/staff/BethanyD.png';
import BridgetE from '../../assets/staff/BridgetE.jpg';
import MakenaT from '../../assets/staff/MakenaT.png';
import MaryahB from '../../assets/staff/MaryahB.jpg';
import SushantV from '../../assets/staff/SushantV.png';
import DawnC from '../../assets/staff/DawnC.png';
import ThaliaV from '../../assets/staff/ThaliaV.jpg';

import { HoverCardBorder } from "../styled/BPSCards";
import { FadeScroll } from "../styled/Motion.styled";

const StaffBios = styled.div`
    p {
        font-size: 1rem;
    }

    h5 {
        font-size: 1.125rem;
    }

    img {
        border-radius: 100%;
        height: 150px;
        width: 150px;
        object-fit: cover;
        margin-bottom: 1rem;
    }
`

const StaffCards = () => {
    return (
        <>
            <Container fluid className="text-center">
                <StaffBios>
                    <FadeScroll>
                        <Row className="justify-content-center">
                            <Col lg={3} className="my-3">
                                <HoverCardBorder>
                                    <img src={GinaG} />
                                    <h5>Gina G.</h5>
                                    <p>Founder, CEO</p>
                                    <p>
                                        The driving force for implementing innovative prepaid solutions. Best Payment Solutions was Gina's vision to support corporate clients with best-in-class staff and prepaid partners while reducing client costs.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                            <Col lg={3} className="my-3">
                                <HoverCardBorder>
                                    <img src={SushantV} />
                                    <h5>Sushant V.</h5>
                                    <p>Chief Technology Officer</p>
                                    <p>
                                        With over 17 years of experience designing, developing, and overseeing Prepaid Card Platforms, Sushant oversees the entire development cycle of all internal and client-facing  programs.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                        </Row>
                    </FadeScroll>
                    <FadeScroll>
                        <Row className="justify-content-center">
                            <Col xl={3} lg={4} className="my-3">
                                <HoverCardBorder>
                                    <img src={AnnaG} />
                                    <h5>Anna G.</h5>
                                    <p>Vice President of Operations</p>
                                    <p>
                                        From project implementation to Account Management, Anna works closely with all departments of the Best Payment Solutions team to ensure a seamless turnover.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                            <Col xl={3} lg={4} className="my-3">
                                <HoverCardBorder>
                                    <img src={BridgetE} />
                                    <h5>Bridget E.</h5>
                                    <p>Director of Human Resources & Training</p>
                                    <p>
                                        Bridget acts to ensure Best Payment Solutions is a great place to work. With thoughtful strategies, she optimizes our organization's mission and talent strategy through staffing, performance evaluations, health and safety, as well as training and development.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                            <Col lg={3} className="my-3">
                                <HoverCardBorder>
                                    <img src={AnuV} />
                                    <h5>Anu V.</h5>
                                    <p>Director of Technology</p>
                                    <p>
                                        Working closely with all departments, Anu designs, builds, and maintains our internal and external systems and applications. She partners with stakeholders to define our website,  database structure, and applications.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                        </Row>
                    </FadeScroll>
                    <FadeScroll>
                        <Row className="justify-content-center">
                            <Col lg={3} className="my-3">
                                <HoverCardBorder>
                                    <img src={DawnC} />
                                    <h5>Dawn C.</h5>
                                    <p>Director of Accounting</p>
                                    <p>
                                        Working closely with our Account Managers, Dawn is responsible for program policies and procedures, and ensuring program reporting is validated for our clients.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                            <Col lg={3} className="my-3">
                                <HoverCardBorder>
                                    <img src={MakenaT} />
                                    <h5>Makena T.</h5>
                                    <p>Creative Director</p>
                                    <p>
                                        From conception to implementation, Makena is oversees creation of all marketing materials and branded assets, both internally and client-facing.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                            <Col lg={3} className="my-3">
                                <HoverCardBorder>
                                    <img src={MaryahB} />
                                    <h5>Maryah B.</h5>
                                    <p>Customer Service Manager</p>
                                    <p>
                                        Maryah is a Customer Service Star. She is an expert at navigating the customer's needs and understands that listening to the customer is most important. Maryah has in-depth knowledge of our programs and how to assist customers with the goal of one call resolution in mind.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                        </Row>
                    </FadeScroll>
                    <FadeScroll>
                        <Row className="justify-content-center">
                            <Col lg={3} className="my-3">
                                <HoverCardBorder>
                                    <img src={AnthonyG} />
                                    <h5>Anthony G.</h5>
                                    <p>Business Development Associate</p>
                                    <p>
                                        Anthony is a seasoned sales expert who is focused on client acquisition and satisfaction. He's committed to discovering brands unique needs and connecting them to the right programs and services.
                                    </p>
                                </HoverCardBorder>
                            </Col>
                        </Row>
                    </FadeScroll>
                </StaffBios>
            </Container>
        </>
    );
}


export { StaffCards }
